import { RIN } from '../types';
export default {
  type: RIN,
  service: 'infura.io',
  url: 'https://rinkeby.infura.io/mew',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
